<template>
    <div class="home">
        <div class="menus row-center">
            <div class="menu-left">
                <menu-button @click="menu === 1 ? menu = -1 : menu = 1" :selected="menu === 1" :bg="[
                        require('../assets/img/button.png'),
                        require('../assets/img/button_c.png'),
                    ]" :icons="[
                        require('../assets/img/park.png'),
                        require('../assets/img/park_c.png'),
                    ]" content="园区概况" v-on:onSelected="parkOverview" v-on:onUnselected="clearParkOverview">
                </menu-button>
            </div>
            <div class="menu-right row-center">
                <menu-button @click="menu === 2 ? menu = -1 : menu = 2" :selected="menu === 2" :bg="[
                        require('../assets/img/button.png'),
                        require('../assets/img/button_c.png'),
                    ]" :icons="[
                        require('../assets/img/site.png'),
                        require('../assets/img/site_c.png'),
                    ]" content="站点分布" v-on:onSelected="siteOverview" v-on:onUnselected="clearSiteOverview">
                </menu-button>
                <menu-button @click="menu === 3 ? menu = -1 : menu = 3" :selected="menu === 3" :bg="[
                        require('../assets/img/button.png'),
                        require('../assets/img/button_c.png'),
                    ]" :icons="[
                        require('../assets/img/safety.png'),
                        require('../assets/img/safety_c.png'),
                    ]" content="安防监控" v-on:onSelected="safetyOverview" v-on:onUnselected="clearSafetyOverview">
                </menu-button>
                <menu-button @click="menu === 4 ? menu = -1 : menu = 4" :selected="menu === 4" :bg="[
                        require('../assets/img/button.png'),
                        require('../assets/img/button_c.png'),
                    ]" :icons="[
                        require('../assets/img/electric.png'),
                        require('../assets/img/electric_c.png'),
                    ]" content="电力桥架" v-on:onSelected="electricLine" v-on:onUnselected="clearElectricLine">
                </menu-button>
            </div>
        </div>

        <ParkOverView :projectId="$store.state.projectId" />
        <ElectricChart :paramType="'PROJECT_ID'" />
        <ParkOperationData />
        <Surveillance :areaId="-1" :cType="currentType" :cDetails="currentDetails"/>
        <Distribution :areaId="-1" />

        <iframe name="GIS" frameborder="0" width="100%" height="100%" ref="iframeDom"
            :src=" url + $store.state.gisUrl + '.html'">
        </iframe>
    </div>
</template>

<script>
    import ParkOverView from "./contentBlock/ParkOverView";
    import ElectricChart from './contentBlock/ElectricChart';
    import ParkOperationData from './contentBlock/ParkOperationData';
    import Surveillance from './contentBlock/Surveillance';
    import Distribution from './contentBlock/Distribution';
    import MenuButton from "../components/MenuButton";
    import {
        config
    } from '../config'
    import {
        GetAlarmList,
    } from "../components/Request";
    import DateDiff from "../components/DateDiff"

    export default {
        name: "Home",
        components: {
            ParkOverView,
            ElectricChart,
            ParkOperationData,
            Surveillance,
            Distribution,
            MenuButton,
        },
        data() {
            return {
                // 底部导航菜单
                menu: 0,

                // 安防类型
                currentType: 0,
                // 安防设备
                currentDetails: 0,

                // 顶部报警事件
                alarmState: false,
                alarm: {
                    type: '遥测越限事件',
                    area: 'A栋生产车间',
                    text: '动力回路-过压报警',
                    time: '一小时前',
                },

                url: config.gisUrl,
                iframeWin: {},

            };
        },
        mounted() {
            // console.log(this.$refs.test) //  可以拿到整个子组件
            this.iframeWin = this.$refs.iframeDom.contentWindow;
            window.addEventListener("message", this.handleMessage);
        },
        beforeDestroy(){
            window.removeEventListener("message", this.handleMessage)
        },
        methods: {
            parkOverview() {
                this.iframeWin.postMessage({
                        cmd: "parkOverview",
                    },
                    "*"
                );
            },
            clearParkOverview() {
                this.iframeWin.postMessage({
                        cmd: "clearParkOverview",
                    },
                    "*"
                );
            },
            siteOverview() {
                this.iframeWin.postMessage({
                        cmd: "siteOverview",
                    },
                    "*"
                );
            },
            clearSiteOverview() {
                this.iframeWin.postMessage({
                        cmd: "clearSiteOverview",
                    },
                    "*"
                );
            },
            safetyOverview() {
                this.iframeWin.postMessage({
                        cmd: "safetyOverview",
                    },
                    "*"
                );
            },
            clearSafetyOverview() {
                this.iframeWin.postMessage({
                        cmd: "clearSafetyOverview",
                    },
                    "*"
                );
            },
            electricLine() {
                this.iframeWin.postMessage({
                        cmd: "electricLine",
                    },
                    "*"
                );
            },
            clearElectricLine() {
                this.iframeWin.postMessage({
                        cmd: "clearElectricLine",
                    },
                    "*"
                );
            },
            showAlarmPosition() {
                this.iframeWin.postMessage({
                        cmd: "showAlarmPosition",
                        value: this.alarm
                    },
                    "*"
                );
            },
            handleMessage(event) {
                const data = event.data;
                // console.log(data)
                switch (data.cmd) {
                    case "returnData":
                        console.log("得到html数据: " + data.params.data);
                        let val = data.params.data
                        if (val.type == "site") {
                            if (val.id == -1) {
                                this.$message({
                                    message: "此站点暂无监控",
                                    center: true,
                                });
                            } else if (val.id != -1) {
                                this.$router.push({
                                    path: "/site/" + val.id
                                });
                            }
                        } else if (val.type == "monitor") {
                            this.currentType = 0;
                            this.currentDetails = val.id;
                        }
                        break;
                }
            },
        },
    };
</script>


<style lang="less" scoped>
    .home {
        margin: 0;
        padding: 0;
        width: 100vw;
        height: 100vh;
        overflow: hidden;
    }

    .alarm {
        .w(604);
        .h(70);
        background-image: url(../assets/img/背板.png);
        background-size: 100% 100%;
        position: fixed;
        top: 1440/108vh;
        left: 6590/192vw;
        display: flex;
        justify-content: center;
        align-items: center;

        .alarm-container {
            .w(596);
            .h(31);
            background: rgba(3, 13, 24, 0.5);
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            color: #E6F3FD;
            cursor: pointer;

            .icon {
                .w(19);
                .h(18);
                background-image: url(../assets/img/警告.png);
                background-size: 100% 100%;
            }

            .text {
                .w(350);
                .h(31);
                line-height: 1.5;
                display: flex;
                justify-content: flex-start;
                align-items: center;
            }

            .time {
                .w(100);
                .h(31);
                display: flex;
                justify-content: flex-end;
                align-items: center;
            }

            .position {
                .w(14);
                .h(16);
                background-image: url(../assets/img/position.png);
                background-size: 100% 100%;
            }
        }
    }

    .menus {
        .w(1015);
        position: fixed;
        .wh(449, 54);
        left: @w;
        bottom: @h;
        justify-content: space-between;

        .menu-left {
            width: 160 / 1015 * 100%;
        }

        .menu-right {
            width: (1 - 160 / 1015) * 100%;

            justify-content: flex-end;

            .btn {
                .wh(16, 0);
                margin-left: @w;
            }
        }
    }

    .parkOverview {
        width: 1600/192vw;
        height: 480/108vh;
        position: fixed;
        bottom: 500/108vh;
        left: 4490/192vw;
        background-size: 100% 100%;
    }

    .parkOverview_c {
        width: 1600/192vw;
        height: 480/108vh;
        position: fixed;
        bottom: 500/108vh;
        left: 4490/192vw;
        background-size: 100% 100%;
    }
</style>